import { useCallback, useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { useFastshiftAnalyticsData, useFireAnalyticsEvents } from '@/analytics';
import { SourceKey, ActionKey, ActionSubjectKey, ActionSubjectIdKey } from '@/analytics/constants';
export const use404DisplayAnalytics = () => {
	const location = useLocation();

	const { identityAttrs: screenIdentityAttrs } = useFastshiftAnalyticsData();
	const { identityAttrs: uiIdentityAttrs } = useFastshiftAnalyticsData(true);

	const { fireScreenEvent } = useFireAnalyticsEvents(screenIdentityAttrs);
	const { fireUIEvent } = useFireAnalyticsEvents(uiIdentityAttrs);

	// Screen event - when 404 page is displayed
	useEffect(() => {
		if (!screenIdentityAttrs) return;

		fireScreenEvent({
			name: SourceKey.FASTSHIFT_PORTAL_404_SCREEN,
			attributes: {
				pageRoute: location.pathname,
			},
		});
	}, [fireScreenEvent, screenIdentityAttrs, location.pathname]);

	// UI event callback for home link click
	const sendGoBackToHomeLinkClickUIEvent = useCallback(() => {
		fireUIEvent({
			action: ActionKey.CLICKED,
			actionSubject: ActionSubjectKey.LINK,
			actionSubjectId: ActionSubjectIdKey.GO_BACK_TO_HOME_LINK,
			source: SourceKey.FASTSHIFT_PORTAL_404_SCREEN,
			attributes: {
				pageRoute: location.pathname,
			},
		});
	}, [fireUIEvent, location.pathname]);

	return {
		sendGoBackToHomeLinkClickUIEvent,
	};
};
